import { render, staticRenderFns } from "./PresenterOverlay.vue?vue&type=template&id=608cdd8a&scoped=true"
import script from "./PresenterOverlay.vue?vue&type=script&lang=js"
export * from "./PresenterOverlay.vue?vue&type=script&lang=js"
import style0 from "./PresenterOverlay.vue?vue&type=style&index=0&id=608cdd8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608cdd8a",
  null
  
)

export default component.exports